<template>
  <rich-button @click="commands.underline" v-bind:isActive="isActive.underline()" v-bind:icon="'underline'" />
</template>

<script>
  import UnderlineButton from './UnderlineButton.ts'
  export default UnderlineButton
</script>
